module.exports = __webpack_public_path__ + "img/android-chrome-192x192.a5667082.png";